import ReactDOM from "react-dom/client";
import App from "./App";
import GlobalStyle from "./components/Styles/GlobalStyle/GlobalStyle";
import { ConfigProvider } from "antd";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <ConfigProvider
        theme={{
            token: {
                colorPrimary: "#191A1C",
                fontFamily: "Inter, sans-serif",
            },
            components: {
                Menu: {
                    itemSelectedBg: "#191A1C", 
                    itemSelectedColor: "#ffffff", 
                    itemHoverColor: "#191A1C",
                    itemHoverBg: "#f0f0f0",
                },
                Select: {
                    optionSelectedBg: "#191A1C",
                    optionSelectedColor: "#ffffff",
                    optionActiveBg: "#f0f0f0",
                },
            },
        }}
    >
        <GlobalStyle>
            <App />
        </GlobalStyle>
    </ConfigProvider>
);
